import React from "react";

import { Accordion, Button, Card } from "react-bootstrap";
import { createAxAdditionalDocument, fetchElectronicSigningRecords } from "../../api/signing-records/actions";
import { fetchTilbodMultiCustomer } from "../../api/offers/actions";
import { SvgCheckIcon, SvgDownloadIcon } from "../svg";
import { openModal } from "../../api/gui/actions";
import { SigningModal } from "../modals";
import { store } from '../../store'
import { getContractFile } from "../../utils";
import SigningText from "../signing-text";
import Alert from 'react-bootstrap/Alert';

class MyPagesSigning extends React.Component {
    constructor(props) {
        super(props)

        this.timer = null
        this.timer2 = null

        this.createSigning = this.createSigning.bind(this)
    }

    componentDidMount() {
        if ( this.timer === null) {
            this.timer = setInterval(() => this.props.dispatch(fetchTilbodMultiCustomer()), 5000)
            this.timer2 = setInterval(() => this.props.dispatch(fetchElectronicSigningRecords(this.props.customerId)), 5000)
        }
    }

    createSigning(obj) {
        Promise.resolve(this.props.dispatch(createAxAdditionalDocument(obj)))
        .then((result)=>{
            Promise.resolve(this.props.dispatch(fetchTilbodMultiCustomer()))
            .then((result) => {
                this.props.dispatch(openModal(`SigningModal-${obj.recordId}`))
            })
        })
    }

    getSignedDocumentUrl(contractFile) {
        return `/api/v1/contractfile/${contractFile.id}/dokobit/`
    }

    render () {
        const {signingRecords, customerOffers, additionalAxDocuments } = this.props
        const {ElectronicSignature} = signingRecords.data.Customer.ElectronicSignatureList

        let contractFiles = {}
        ElectronicSignature.map((signatureRequest) => {
            let c = getContractFile(signatureRequest.RecId, customerOffers)
            if (c) {
                contractFiles[signatureRequest.RecId] = c
            }
        })

        return(
            <>
                {additionalAxDocuments && additionalAxDocuments.error && additionalAxDocuments.errorMessage &&
                    <Alert variant="danger" className="col-12 xs-mt-50">
                        <Alert.Heading>Villa kom upp í samskiptum</Alert.Heading>
                            <>
                                <hr />
                                <p>
                                    {additionalAxDocuments.errorMessage}
                                </p>
                            </>
                    </Alert>
                }
                    
            
                <SigningText />
                <Accordion defaultActiveKey="0">
                    {ElectronicSignature.map((signatureRequest) =>
                        <Card key={signatureRequest.RecId}>
                            <Card.Header>
                                <Accordion.Toggle eventKey="0" as={Button} variant="link" className="toggle-button limited">

                                    <>{contractFiles[signatureRequest.RecId] && (!contractFiles[signatureRequest.RecId].signing_needed || contractFiles[signatureRequest.RecId].signing_needed && contractFiles[signatureRequest.RecId].status === 'contract_signed' || contractFiles[signatureRequest.RecId].signing_needed && contractFiles[signatureRequest.RecId].status === 'contract_delivered') &&
                                        <span className="check">
                                            <span className="check check-icon big green">
                                                <SvgCheckIcon />
                                            </span>
                                        </span>
                                    }</>

                                    <div>
                                        {signatureRequest.Description}
                                    </div>

                                    <div className="actions ax-signing justify-content-center">
                                        { contractFiles[signatureRequest.RecId] ?
                                            <>
                                                {contractFiles[signatureRequest.RecId].signing_needed && contractFiles[signatureRequest.RecId].status === 'contract_uploaded' && contractFiles[signatureRequest.RecId].active &&
                                                    <a className="btn btn-primary" onClick={() => this.props.dispatch(openModal(`SigningModal-${signatureRequest.RecId}`))}>Undirrita</a>
                                                }
                                                {contractFiles[signatureRequest.RecId].signing_needed && (contractFiles[signatureRequest.RecId].status === 'contract_signed' || contractFiles[signatureRequest.RecId].status === 'contract_delivered') && contractFiles[signatureRequest.RecId].active &&
                                                    <>
                                                        {contractFiles[signatureRequest.RecId].file_url !== "" ?
                                                            <a href={this.getSignedDocumentUrl(contractFiles[signatureRequest.RecId])} download={`${contractFiles[signatureRequest.RecId].description}.pdf`} target="_blank" className="btn btn-primary mt-3"><SvgDownloadIcon /> Undirritað skjal</a>
                                                            :
                                                            <a className="btn btn-primary disabled mt-3" aria-disabled="true"><SvgDownloadIcon /> Undirritað skjal</a>
                                                        }
                                                    </>
                                                }
                                                <SigningModal title={contractFiles[signatureRequest.RecId].description} id={"SigningModal-" + signatureRequest.RecId} signingUrl={contractFiles[signatureRequest.RecId].signing_url} store={store} />
                                            </>
                                            :
                                            <a className="btn btn-primary mt-3" onClick={() => this.createSigning({recordId: signatureRequest.RecId, customerId: signatureRequest.CustAccount})} >Undirrita</a>
                                        }
                                    </div>

                                </Accordion.Toggle>
                            </Card.Header>
                        </Card>

                    )}
                </Accordion>

            </>
        )
    }
}


MyPagesSigning.defaultProps = {
}


export default MyPagesSigning
